import { useState } from 'react';
import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons } from '@/design_system/Footer';
import IconCancel from '@/icons/Cancel.svg';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

import { RecordClientContactDialog } from './shared/RecordClientContactDialog';
import { ArticleActionProps } from './ArticleActions';
import { RefuseValidationDialog } from './ValidateOnBehalfOfClientAction';

export const ContactClientAction = ({ onActionDone }: ArticleActionProps) => {
  const { workflow } = useRequestContext();
  const { article } = useArticleContext();

  const [isConfirmClientContactDialogOpen, setIsConfirmClientContactDialogOpen] = useState(false);

  const chooseArticleServiceTraits = workflow?.nodes.find(
    (node) => 'step' in node && node.step === 'service-choice'
  )?.config?.tasks?.choose_article_service?.traits;

  // If the user that has the task to reach out to the client during validation
  // did not have the possibility to review the workshop quote before,
  // then they may directly refuse the workshop quote
  // without having to reached out to the client first.
  const showRefuseWorkshopQuoteButton =
    article.step?.step === 'validation' && !chooseArticleServiceTraits?.includes('store');

  const [isOpenRefusalDialog, setIsOpenRefusalDialog] = useState(false);

  return (
    <>
      <Footer>
        <FooterButtons>
          {showRefuseWorkshopQuoteButton && (
            <>
              <Button
                variant="secondary-danger"
                size="medium"
                onPress={() => setIsOpenRefusalDialog(true)}
              >
                <IconCancel />
                <Trans id="article.actions.contact-client.refuse-workshop-quote">
                  Refuse workshop quote
                </Trans>
              </Button>
              <RefuseValidationDialog
                isOpen={isOpenRefusalDialog}
                setIsOpen={setIsOpenRefusalDialog}
                onActionDone={onActionDone}
                refusalTypes={['store']}
              />
            </>
          )}

          <Button
            variant="primary"
            size="medium"
            onPress={() => setIsConfirmClientContactDialogOpen(true)}
          >
            <Trans id="article.actions.contact-client.confirm">Record client outreach</Trans>
          </Button>
        </FooterButtons>
      </Footer>
      <RecordClientContactDialog
        isOpen={isConfirmClientContactDialogOpen}
        setIsOpen={setIsConfirmClientContactDialogOpen}
        onSuccess={onActionDone}
      />
    </>
  );
};
